// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cutoff-form__reset-btn[data-v-1b862021]{height:100%!important;font-weight:600}", ""]);
// Exports
module.exports = exports;
